import {
  LISTA_VALIDACAO_PERFIL,
  LISTA_VALIDACAO_PERFIL_SUCESSO,
  LISTA_VALIDACAO_PERFIL_ERRO,
  APROVA_VALIDACAO_PERFIL,
  APROVA_VALIDACAO_PERFIL_SUCESSO,
  REPROVA_VALIDACAO_PERFIL,
  REPROVA_VALIDACAO_PERFIL_SUCESSO,
  VALIDACAO_PERFIL_ERRO,
} from 'constants/ActionTypes';

const INIT_STATE = {
  carregando: false,
  enviando: false,
  items: [],
  total: 0,
  totalPaginas: 0,
  pagina: 1,
  tamanhoPagina: 20,
  statusFiltro: 'PENDENTE',
  erro: null,
  sucesso: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_VALIDACAO_PERFIL:
      return { ...state, carregando: true, erro: null, sucesso: false, statusFiltro: action.payload.status };

    case LISTA_VALIDACAO_PERFIL_SUCESSO:
      return {
        ...state,
        carregando: false,
        items: action.payload.items,
        total: action.payload.total,
        totalPaginas: action.payload.totalPaginas,
        pagina: action.payload.pagina,
        tamanhoPagina: action.payload.tamanhoPagina,
      };

    case LISTA_VALIDACAO_PERFIL_ERRO:
      return { ...state, carregando: false, erro: action.payload };

    case APROVA_VALIDACAO_PERFIL:
    case REPROVA_VALIDACAO_PERFIL:
      return { ...state, enviando: true, erro: null, sucesso: false };

    case APROVA_VALIDACAO_PERFIL_SUCESSO:
    case REPROVA_VALIDACAO_PERFIL_SUCESSO:
      return { ...state, enviando: false, sucesso: true };

    case VALIDACAO_PERFIL_ERRO:
      return { ...state, enviando: false, erro: action.payload };

    default:
      return state;
  }
};
